// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconAccount = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" viewBox="0 0 34 35">
            <path
                fill="currentColor"
                d="M17,0 C7.61015666,0 0,7.61015666 0,17 C0,26.3898433 7.61015666,34 17,34 C26.3898433,34 34,26.3898433 34,17 C34,7.61015666 26.3898433,0 17,0 Z M17,31.875 C13.8629684,31.875 10.9543744,30.8935157 8.5531252,29.2293752 C8.82539022,25.9582027 11.5414065,23.375 14.875,23.375 L19.125,23.375 C22.4619141,23.375 25.1772666,25.9608595 25.4475385,29.2293752 C23.0429688,30.8921883 20.1343758,31.875 17,31.875 Z M27.3394539,27.6714852 C26.4031254,23.9925773 23.0894539,21.25 19.124999,21.25 L14.875,21.25 C10.908555,21.25 7.59687459,23.9925773 6.66054606,27.6728126 C3.86949146,24.9089848 2.12499899,21.1835937 2.12499899,17 C2.12499899,8.79882812 8.79882711,2.125 16.999999,2.125 C25.2011709,2.125 31.874999,8.79882812 31.874999,17 C31.874999,21.1835937 30.1285154,24.9089848 27.3394529,27.6714852 L27.3394539,27.6714852 Z M16.999999,8.5 C14.0648429,8.5 11.687499,10.8773429 11.687499,13.8125 C11.687499,16.747656 14.0648429,19.125 16.999999,19.125 C19.935156,19.125 22.312499,16.7463276 22.312499,13.8125 C22.312499,10.8773429 19.935156,8.5 16.999999,8.5 Z M16.999999,17 C15.2402334,17 13.812499,15.5722656 13.812499,13.8125 C13.812499,12.0527344 15.2402334,10.625 16.999999,10.625 C18.7597646,10.625 20.187499,12.0547265 20.187499,13.8125 C20.187499,15.5702735 18.7597646,17 16.999999,17 Z"
                transform="translate(0 .25)"
            />
        </svg>
    );
};

export default React.memo(IconAccount);
